import { GET_SETTING_REQUEST } from './constants';

export const getForWeb = (onError) => ({
  type: GET_SETTING_REQUEST,
  onError
});
